import type { TranslationsBase } from './ko';

const vi: TranslationsBase = {
  lang: 'vi',
  langName: 'Tiếng Việt',
  flag: '🇻🇳',

  siteTitle: 'Đề thi TOEFL mô phỏng miễn phí — AI phân tích | Power TOEFL 2026',
  siteDescription: 'Luyện TOEFL iBT 2026 miễn phí với 3.500+ câu hỏi. AI phân tích điểm yếu, ôn tập Ebbinghaus, bảng quy đổi điểm — nền tảng luyện TOEFL tiếng Việt.',
  ogTitle: 'Đề thi TOEFL mô phỏng miễn phí — AI phân tích | Power TOEFL 2026',

  navGrammar: 'Ngữ pháp',
  navPractice: 'Luyện theo phần',
  navScoreChart: 'Bảng điểm',
  navVocabulary: 'Từ vựng',
  navTips: 'Mẹo/Chiến lược',
  navFAQ: 'FAQ',
  navReading: 'Reading',
  navListening: 'Listening',
  navSpeaking: 'Nói',
  navWriting: 'Viết',
  navQuestionPool: 'Đề thi',
  navResources: 'Tài liệu',

  loginButton: 'Đăng nhập',
  wrongAnswers: 'Sổ lỗi sai',
  logout: 'Đăng xuất',
  loginRequired: 'Sổ lỗi sai & tiếp tục làm bài cần đăng nhập.',
  googleLogin: 'Bắt đầu với Google, mở tính năng premium',

  heroBadge: 'Hệ thống luyện TOEFL cao cấp',
  heroTitle1: 'Nền tảng duy nhất',
  heroTitle2: 'cho điểm TOEFL cao',
  heroDesc1: 'Từ đề thi mô phỏng 4 kỹ năng dạng 2026 đến sổ lỗi sai,',
  heroDesc2: 'hỗ trợ bạn đạt mục tiêu điểm số hoàn hảo.',

  lcTitle: 'Listening',
  lcSubtitle: 'Listening — 47 câu',
  lcTime: '29 phút',
  rcTitle: 'Reading',
  rcSubtitle: 'Reading — 50 câu',
  rcTime: '30 phút',
  startTest: 'Bắt đầu thi',
  fullTestStart: 'Bắt đầu toàn bộ (Reading → Listening)',
  fullTestDesc: 'Làm lần lượt hai phần',

  part1: 'Academic Reading (20)',
  part2: 'Conversations (10)',
  part3: 'Lectures (18)',

  moreTools: 'Công cụ học tập khác',
  practiceLabel: 'Luyện theo phần',
  practiceDesc: 'Học riêng Reading·Listening',
  scoreChartLabel: 'Bảng điểm',
  scoreChartDesc: 'Số đúng → Điểm quy đổi',
  vocabLabel: 'Từ vựng',
  vocabDesc: 'Từ vựng TOEFL thiết yếu',
  tipsLabel: 'Mẹo/Chiến lược',
  tipsDesc: 'Chiến lược Listening·Reading',
  catLabel: 'CAT thích ứng',
  catDesc: 'Tự động điều chỉnh độ khó',
  fullTestCardLabel: 'Full Test mô phỏng',
  fullTestCardDesc: 'Reading + Listening thực chiến',

  statQuestions: 'câu',
  statParts: 'phần',
  statMinutes: 'phút',

  footerMockTest: 'Luyện tập',
  footerQuestionPool: 'Ngân hàng đề',
  footerPractice: 'Luyện theo section',
  footerStudy: 'Học tập',
  footerBooks: 'Sách khuyên dùng',
  footerEtc: 'Khác',
  footerLC: 'Luyện Listening',
  footerRC: 'Luyện Reading',
  footerSpeaking: 'Luyện Speaking',
  footerWriting: 'Luyện Writing',
  footerLCStrategy: 'Chiến lược Listening',
  footerRCStrategy: 'Chiến lược RC',
  footerCopyright: '© 2026 Power TOEFL. All rights reserved.',
  footerDisclaimer: 'TOEFL® là thương hiệu đã đăng ký của ETS. Power TOEFL không liên kết hoặc được ETS chứng nhận, là nền tảng học TOEFL hoạt động độc lập.',

  faqTitle: '❓ Câu hỏi thường gặp (FAQ)',
  faqDesc: 'Xem các câu hỏi thường gặp về TOEFL và Power TOEFL.',
  faqPageTitle: 'Tính điểm TOEFL · Cách đăng ký · Thời hạn — FAQ tổng hợp 2026 | Power TOEFL',
  faqPageDesc: 'Đăng ký thi TOEFL thế nào? Điểm hết hạn khi nào? Quy đổi điểm ra sao? — 30 câu hỏi phổ biến nhất được giải đáp trong một trang.',
  faqMore: 'Có câu hỏi khác? Chúng tôi liên tục cập nhật FAQ.',

  scoreChartPageTitle: 'Bảng quy đổi điểm TOEFL 2026 — Đúng bao nhiêu câu được bao nhiêu điểm? | Power TOEFL',
  scoreChartPageDesc: 'Kiểm tra điểm TOEFL ngay từ số câu đúng. Bảng LC·RC riêng + hướng dẫn học theo mục tiêu điểm. Hoàn toàn miễn phí.',
  scoreChartHeading: '📊 Bảng quy đổi điểm TOEFL',
  scoreChartIntro: 'Các bảng 0–30 theo phần và tổng 0–120 là ước tính học tập của Power TOEFL trên thang cũ/dùng để so sánh. Báo cáo chính thức năm 2026 ưu tiên điểm từng phần và tổng thể 1–6 theo bước 0,5.',
  scoreChartLC: 'Bảng LC (Listening)',
  scoreChartRC: 'Bảng RC (Reading)',
  scoreChartCorrect: 'Số đúng',
  scoreChartConverted: 'Điểm quy đổi',
  scoreChartUnit: 'câu',
  scoreChartPointUnit: 'điểm',
  scoreGuideTitle: '🎯 Hướng dẫn theo mục tiêu điểm',
  scoreGuide900: 'Cao nhất',
  scoreGuide900Desc: 'Cần đúng LC 90+ / RC 90+. Gần như điểm tuyệt đối.',
  scoreGuide800: 'Cao',
  scoreGuide800Desc: 'Mục tiêu LC 80+ / RC 80+. Tiếng Anh thương mại nâng cao.',
  scoreGuide700: 'Trung bình-Cao',
  scoreGuide700Desc: 'Đáp ứng hầu hết yêu cầu tuyển dụng. Cần học đều đặn.',
  scoreGuide600: 'Trung bình',
  scoreGuide600Desc: 'Có nền tảng tốt. Nên tập trung Reading và Listening.',
  scoreChartFaqTitle: '❓ Câu hỏi thường gặp về điểm TOEFL',
  scoreChartCtaTitle: 'Kiểm tra trình độ ngay',
  scoreChartCtaDesc: 'Làm bài thi thử miễn phí dạng 2026 để biết điểm dự kiến.',

  vocabPageTitle: '600 từ vựng TOEFL hay ra nhất — Phân loại theo chủ đề + ví dụ | Power TOEFL',
  vocabPageDesc: 'Kinh doanh · Nhân sự · Marketing · Tài chính · Sản xuất · Đời sống — 6 chủ đề, 600 từ. Bấm để xem nghĩa và ví dụ ngay.',
  vocabHeading: '📚 Từ vựng TOEFL thiết yếu',
  vocabIntro: 'Học từ vựng theo chủ đề. Nhấn để xem nghĩa.',
  vocabShowAll: 'Hiện tất cả',
  vocabHideAll: 'Ẩn tất cả',
  vocabReset: 'Đặt lại',
  vocabClickToReveal: 'Nhấn để xem nghĩa',
  vocabMotivation: 'Ôn tập đều đặn, điểm TOEFL sẽ tăng! 🚀',
  vocabCatNaturalScience: 'Khoa học tự nhiên',
  vocabCatSocialScience: 'Khoa học xã hội',
  vocabCatHumanities: 'Nhân văn',
  vocabCatLifeScience: 'Khoa học sự sống',
  vocabCatTechnology: 'Công nghệ/Kỹ thuật',
  vocabCatAcademicGeneral: 'Học thuật chung',
  vocabSynonyms: 'Từ đồng nghĩa',
  vocabAntonyms: 'Từ trái nghĩa',
  vocabMyWords: 'Từ vựng của tôi',
  vocabAddWord: 'Thêm từ',
  vocabAddWordPlaceholder: 'Nhập từ tiếng Anh',
  vocabMyWordsEmpty: 'Chưa có từ nào. Hãy thêm từ ở trên!',
  vocabDeleteWord: 'Xóa',
  vocabLookingUp: 'Đang tìm...',
  vocabQuizTitle: 'Kiểm tra từ vựng',
  vocabQuizDesc: 'Kiểm tra từ đồng nghĩa và trái nghĩa bạn đã học!',
  vocabQuizMode_synonym: 'Từ đồng nghĩa',
  vocabQuizMode_antonym: 'Từ trái nghĩa',
  vocabQuizMode_mixed: 'Hỗn hợp',
  vocabQuizClose: 'Đóng',
  vocabQuizNoQuestions: 'Danh mục này không đủ câu hỏi.',
  vocabQuizBack: 'Quay lại',
  vocabQuizResult: 'Kết quả',
  vocabQuizExcellent: 'Xuất sắc! 🎉',
  vocabQuizGood: 'Tốt lắm! Luyện thêm chút nữa sẽ hoàn hảo!',
  vocabQuizKeepGoing: 'Tiếp tục cố gắng! 💪',
  vocabQuizRetry: 'Làm lại',
  vocabQuizFindSynonym: 'Chọn từ đồng nghĩa của từ sau',
  vocabQuizFindAntonym: 'Chọn từ trái nghĩa của từ sau',
  vocabQuizNext: 'Tiếp',
  vocabQuizFinish: 'Xem kết quả',
  vocabQuizStart: 'Bắt đầu kiểm tra',

  tipsLCPageTitle: 'Cách tăng điểm Listening TOEFL | Luyện LC thực chiến — Power TOEFL',
  tipsLCPageDesc: 'Cách tăng điểm Listening TOEFL bằng phương pháp luyện thực chiến Conversations·Lectures. Kỹ thuật đọc trước, tránh bẫy.',
  tipsLCHeading: '🎧 Cách tăng điểm Listening TOEFL',
  tipsLCIntro: 'Tổng hợp chiến lược và phương pháp luyện thực chiến TOEFL LC Conversations·Lectures.',
  tipsLCButton: 'Chiến lược LC',
  tipsRCButton: 'Chiến lược RC',
  tipsLCPractice: 'Luyện LC thực tế',
  tipsLCPracticeDesc: 'Đã nắm chiến lược? Hãy luyện với đề mô phỏng.',
  tipsLCStartTest: 'Bắt đầu đề LC',
  tipsRCPageTitle: 'Giải quyết thiếu thời gian Reading TOEFL | Chiến lược phân bổ RC — Power TOEFL',
  tipsRCPageDesc: 'Cách giải quyết thiếu thời gian Reading TOEFL Reading. Chiến lược phân bổ thời gian, đọc nhanh.',
  tipsRCHeading: '📖 Giải quyết thiếu thời gian Reading TOEFL',
  tipsRCIntro: 'Tổng hợp chiến lược phân bổ thời gian RC và cách chinh phục từng phần.',
  tipsRCPractice: 'Luyện RC thực tế',
  tipsRCPracticeDesc: 'Đã nắm chiến lược? Hãy luyện với đề mô phỏng.',
  tipsRCStartTest: 'Bắt đầu đề RC',

  practicePartMeta: {
    '1': { title: 'TOEFL Reading — Chiến lược đọc bài học thuật 20 câu | Power TOEFL', desc: 'Cách đọc hiệu quả bài viết học thuật TOEFL Reading. Quét keyword, suy luận, tóm tắt — tất cả trong một.' },
    '2': { title: 'TOEFL Listening Conversations — Chiến lược ghi chú | Power TOEFL', desc: 'Chiến lược cốt lõi TOEFL Listening Conversations. Nắm mục đích hội thoại, suy luận thái độ, kỹ thuật ghi chú.' },
    '3': { title: 'TOEFL Listening Lectures — Chiến lược 18 câu | Power TOEFL', desc: 'Chiến lược TOEFL Listening Lectures. Nắm chủ đề bài giảng, suy luận ý giáo sư, phân tích ví dụ để đạt điểm cao.' },
  } as Record<string, { title: string; desc: string }>,

  practicePartContent: {
    '1': {
      intro: 'TOEFL Reading đọc bài viết học thuật (khoảng 700 từ) và trả lời câu hỏi về chủ đề, chi tiết, suy luận, từ vựng và tóm tắt. 35 phút cho 2 bài, tổng 20 câu. Nắm câu chủ đề mỗi đoạn và quét keyword là chìa khóa quản lý thời gian.',
      commonTypes: ['Chủ đề/Mục đích (What is the passage mainly about?)', 'Chi tiết (According to the passage...)', 'Từ vựng (The word X is closest in meaning to...)', 'Suy luận (What can be inferred?)', 'Chèn câu (Insert text)', 'Tóm tắt (Prose Summary — chọn 3 ý chính)'],
      strategy: ['Đọc câu hỏi trước, nhớ 2-3 keyword rồi quét bài', 'Tập trung câu đầu mỗi đoạn (câu chủ đề) — bài TOEFL thường mở đầu bằng ý chính', 'Câu hỏi từ vựng dựa vào ngữ cảnh chứ không phải nghĩa từ điển', 'Câu hỏi tóm tắt chỉ chọn ý chính, không chọn chi tiết nhỏ'],
      recommendedFor: ['Người mới bắt đầu TOEFL — xây dựng cảm giác đọc học thuật', 'Mục tiêu Reading 20+ — cần chiến lược phân bổ thời gian', 'Yếu câu suy luận/tóm tắt — luyện tập trung theo dạng'],
      faq: [
        { q: 'TOEFL Reading thiếu thời gian thì sao?', a: 'Phân bổ 17-18 phút mỗi bài, câu khó đánh dấu bỏ qua. Dành ít nhất 3 phút cho câu tóm tắt.' },
        { q: 'Gặp từ không biết trong câu hỏi từ vựng?', a: 'Suy luận từ ngữ cảnh. Câu trước và sau chỗ trống là manh mối. Nghĩa có thể khác từ điển.' },
        { q: 'Câu hỏi tóm tắt (Prose Summary) làm thế nào?', a: 'Chọn 3 đáp án đại diện ý chính mỗi đoạn. Đáp án chỉ liên quan chi tiết 1 đoạn là sai.' },
      ],
    },
    '2': {
      intro: 'TOEFL Listening Conversations nghe hội thoại trong khuôn viên trường (giáo sư-sinh viên, nhân viên-sinh viên), dài 3-5 phút, trả lời 5 câu. Trọng tâm là nắm mục đích hội thoại, chi tiết và thái độ người nói.',
      commonTypes: ['Mục đích hội thoại (Why does the student visit the professor?)', 'Chi tiết (What does the professor say about...?)', 'Thái độ/Ý định (What is the student\'s attitude?)', 'Hành động tiếp theo (What will the student probably do next?)'],
      strategy: ['Nắm ngay mục đích từ phần mở đầu hội thoại', 'Ghi chú thông tin cốt lõi (tên, ngày, điều kiện)', 'Chú ý giọng điệu và cảm xúc — manh mối chính cho câu hỏi thái độ', 'Tập trung vào kết luận và hành động tiếp theo ở cuối hội thoại'],
      recommendedFor: ['TOEFL Listening dưới 15 — bắt đầu từ hội thoại ngắn', 'Muốn bắt đầu từ dạng dễ hơn Lectures', 'Cần luyện kỹ thuật ghi chú'],
      faq: [
        { q: 'Conversations có bắt buộc ghi chú không?', a: 'Có. TOEFL hiển thị câu hỏi sau khi nghe xong, nếu không ghi chú sẽ bỏ lỡ chi tiết. Dùng viết tắt và ký hiệu để ghi nhanh.' },
        { q: 'Làm sao nhận biết thái độ người nói?', a: 'Giọng điệu (tự tin/không chắc), biểu cảm ("I\'m not sure about that", "That sounds great"), lặp lại nhấn mạnh là manh mối chính.' },
      ],
    },
    '3': {
      intro: 'TOEFL Listening Lectures nghe bài giảng đại học (5-7 phút) trả lời 6 câu. Bao gồm sinh học, lịch sử, nghệ thuật, địa chất. Nắm chủ đề, suy luận ý giáo sư, phân tích mục đích ví dụ là cốt lõi.',
      commonTypes: ['Chủ đề bài giảng (What is the lecture mainly about?)', 'Ý giáo sư (Why does the professor mention X?)', 'Chi tiết (According to the professor...)', 'Suy luận (What does the professor imply?)', 'Cấu trúc bài giảng (How does the professor organize the lecture?)'],
      strategy: ['1-2 phút đầu nắm chủ đề và mục đích — dạng câu hỏi cơ bản nhất', 'Luôn nghĩ tại sao giáo sư đưa ví dụ — cốt lõi "Why does the professor mention X?"', 'Cụm từ chuyển đổi (Now, let\'s move on to...) báo hiệu chủ đề phụ mới', 'Suy luận ẩn ý, hài hước, câu hỏi tu từ của giáo sư'],
      recommendedFor: ['Mục tiêu TOEFL Listening 20+ — Lectures quyết định điểm', 'Khó nghe bài giảng học thuật', 'Muốn xây dựng hệ thống ghi chú'],
      faq: [
        { q: '"Why does the professor mention X?" làm thế nào?', a: 'Giáo sư đưa ví dụ/so sánh/thí nghiệm thường để bổ sung hoặc đối chiếu khái niệm trước đó. Tìm mục đích trong ngữ cảnh ngay trước điểm đề cập.' },
        { q: 'Lectures không có kiến thức nền có bất lợi không?', a: 'Không. TOEFL cung cấp mọi thông tin cần thiết trong bài giảng. Kiến thức nền có ích nhưng nội dung bài giảng đủ để trả lời mọi câu.' },
      ],
    },
  } as Record<string, { intro: string; commonTypes: string[]; strategy: string[]; recommendedFor: string[]; faq: { q: string; a: string }[] }>,

  practiceRelatedLinks: '📌 Nội dung liên quan',
  practiceOtherParts: 'Chinh phục phần khác',
  practiceMockTestCTA: 'Luyện với đề thi thử',
  practiceTipsLink: 'Xem chiến lược từng phần',
  practiceGrammarLink: 'Học ngữ pháp',

  practiceNotFound: 'Không tìm thấy phần này.',
  practiceQuestionType: 'Loại câu hỏi',
  practiceTips: '💡 Mẹo chinh phục',
  practiceExamples: '📝 Câu hỏi mẫu',
  practiceIntro: '📋 Giới thiệu phần',
  practiceCommonTypes: '📊 Dạng hay ra',
  practiceStrategy: '🎯 Điểm chiến lược',
  practiceRecommendedFor: '👤 Phù hợp với',
  practiceFAQ: '❓ Câu hỏi thường gặp',
  practiceCTA: 'Luyện ngay bây giờ',
  practiceCTADesc: 'Làm Part {0} trong môi trường giống thật.',
  practiceStartTest: 'Bắt đầu đề {0}',
  practiceQuestions: 'câu',
  practicePartSelect: 'Chọn phần',

  roundsTitle: 'Bộ đề thi thử',
  roundLabel: 'TOEFL mô phỏng',
  roundUnit: 'lần',
  comingSoon: 'Sắp có',
  testPrevious: 'Trước',
  testNext: 'Tiếp',
  testQuestion: 'Câu',
  testQuestionPrompt: 'Đọc câu hỏi và chọn đáp án đúng.',
  testMarkAnswer: 'Hãy đánh dấu số đáp án đúng.',
  testSelect: 'Chọn',
  testShowAnswer: 'Xem đáp án và giải thích',
  testCorrect: 'Chính xác!',
  testIncorrect: 'Sai rồi.',
  testLoginPrompt: 'Cần đăng nhập để dùng sổ lỗi sai và tiếp tục.',
  testGoogleLogin: 'Đăng nhập bằng Google',
  roundSelect: 'Chọn bộ đề khác',
  testAnswered: 'Đã trả lời',
  testSubmit: 'Nộp bài',
  testSubmitTitle: 'Nộp bài {0}?',
  testSubmitDesc: 'Đã trả lời {1}/{0} câu.',
  testUnanswered: '{0} câu chưa trả lời.',
  testCannotUndo: 'Không thể hoàn tác.',
  testContinue: 'Tiếp tục',
  testSubmitBtn: 'Nộp',

  resultsTitle: 'Kết quả {0}',
  resultsTimeUsed: 'Thời gian: {0} phút {1} giây',
  resultsEstimatedScore: 'Điểm dự kiến (tối đa 495)',
  resultsCorrect: 'Đúng',
  resultsIncorrect: 'Sai',
  resultsAccuracy: 'Tỷ lệ đúng',
  resultsReview: 'Xem lại đáp án',
  resultsYourAnswer: 'Đáp án của bạn: {0}',
  resultsCorrectAnswer: 'Đáp án đúng: {0}',
  resultsNoAnswer: 'Chưa trả lời',
  resultsHome: 'Trang chủ',
  resultsWrongNotes: 'Sổ lỗi sai',
  resultsRetry: 'Làm lại',
  resultsShare: 'Chia sẻ kết quả',
  resultsShareText: 'Điểm TOEFL {0} dự kiến của tôi: {1} điểm! ({2}/{3} đúng, {4}%) Kiểm tra miễn phí tại Power TOEFL!',
  resultsShareCopied: 'Đã sao chép vào bộ nhớ tạm!',
  resultsNoResults: 'Không tìm thấy kết quả.',
  resultsGoHome: 'Về trang chủ',
  resultsSaved: 'Đã lưu {0} câu sai vào sổ lỗi',

  wrongAnswersTitle: 'Sổ lỗi sai',
  wrongAnswersSaved: 'Câu hỏi đã lưu',
  wrongAnswersHome: 'Trang chủ',
  wrongAnswersPracticeAll: 'Luyện tất cả',
  wrongAnswersAll: 'Tất cả',
  wrongAnswersNoItems: 'Chưa có lỗi sai nào. Hãy làm bài thi trước!',
  wrongAnswersYourAnswer: 'Đáp án của bạn: {0}',
  wrongAnswersCorrectIs: 'Đáp án đúng: {0}',
  wrongAnswersReviewed: 'Đã ôn tập',
  wrongAnswersRemoved: 'Đã xóa khỏi sổ lỗi',
  wrongAnswersPracticeMode: 'Chế độ luyện',
  wrongAnswersCorrectMsg: 'Chính xác!',
  wrongAnswersIncorrectMsg: 'Sai. Đáp án đúng: {0}',
  wrongAnswersNextQuestion: 'Câu tiếp',
  wrongAnswersFinish: 'Kết thúc',
  wrongAnswersExitPractice: 'Thoát luyện',
  wrongAnswersPracticeComplete: 'Luyện xong!',
  wrongAnswersNoPractice: 'Không có lỗi sai để luyện',
  wrongAnswersLimitNotice: 'Chỉ hiển thị 500 lỗi sai gần nhất.',

  privacyPageTitle: 'Chính sách bảo mật — Power TOEFL',
  privacyPageDesc: 'Chính sách bảo mật của Power TOEFL.',
  privacyHeading: 'Chính sách bảo mật',
  privacyLastUpdated: 'Cập nhật lần cuối: 29 tháng 3, 2026',
  privacyS1Title: '1. Thông tin cá nhân thu thập',
  privacyS1Body: 'Power TOEFL thu thập email, tên và ảnh hồ sơ khi đăng nhập bằng Google. Khi thanh toán, thông tin được xử lý qua dịch vụ thanh toán (Dodo Payments/PayPal) và chúng tôi không lưu trữ thông tin thẻ.',
  privacyS2Title: '2. Mục đích sử dụng',
  privacyS2Body: 'Thông tin được sử dụng để lưu sổ lỗi sai, quản lý tiến độ học, quản lý đăng ký, hỗ trợ khách hàng và cải thiện dịch vụ.',
  privacyS3Title: '3. Lưu trữ và xóa dữ liệu',
  privacyS3Body: 'Khi xóa tài khoản, thông tin cá nhân được xóa ngay. Hồ sơ thanh toán được lưu tối đa 5 năm theo quy định thuế.',
  privacyS4Title: '4. Chia sẻ với bên thứ ba',
  privacyS4Body: 'Chúng tôi chỉ chia sẻ thông tin tối thiểu (email) với Dodo Payments hoặc PayPal để xử lý thanh toán. Không chia sẻ thông tin cá nhân với bên thứ ba khác trừ khi pháp luật yêu cầu.',
  privacyS5Title: '5. Cookie và quảng cáo',
  privacyS5Body: 'Trang web sử dụng Google AdSense để hiển thị quảng cáo và sử dụng cookie cho mục đích này. Bạn có thể quản lý cookie trong cài đặt trình duyệt.',
  privacyS6Title: '6. Truyền dữ liệu quốc tế',
  privacyS6Body: 'Dịch vụ sử dụng máy chủ nước ngoài và dữ liệu có thể được truyền quốc tế để xử lý thanh toán. Chúng tôi áp dụng các biện pháp bảo mật phù hợp.',
  privacyS7Title: '7. Quyền của người dùng',
  privacyS7Body: 'Người dùng có thể yêu cầu xem, chỉnh sửa hoặc xóa thông tin cá nhân bất kỳ lúc nào. Cư dân EU/EEA được bảo đảm các quyền bổ sung theo GDPR.',
  privacyS8Title: '8. Liên hệ',
  privacyS8Body: 'Mọi thắc mắc về thông tin cá nhân, vui lòng gửi email tới skdaks0731@gmail.com.',

  termsPageTitle: 'Điều khoản sử dụng — Power TOEFL',
  termsPageDesc: 'Điều khoản sử dụng của Power TOEFL.',
  termsHeading: 'Điều khoản sử dụng',
  termsLastUpdated: 'Cập nhật lần cuối: 29 tháng 3, 2026',
  termsS1Title: '1. Tổng quan dịch vụ',
  termsS1Body: 'Power TOEFL là nền tảng học trực tuyến để luyện thi TOEFL, được vận hành bởi ddookddak (tên doanh nghiệp hợp pháp đã đăng ký của chúng tôi), cung cấp tính năng miễn phí và đăng ký Premium (Pro/Lifetime) có phí gồm đề thi mô phỏng, luyện theo phần, tạo câu hỏi AI, sổ lỗi sai.',
  termsS2Title: '2. Điều kiện sử dụng',
  termsS2Body: 'Dịch vụ dành cho mọi người từ 14 tuổi trở lên. Một số tính năng yêu cầu đăng nhập Google, tính năng premium yêu cầu đăng ký có phí.',
  termsS3Title: '3. Quyền sở hữu trí tuệ',
  termsS3Body: 'Nội dung trang web thuộc về Power TOEFL. TOEFL là thương hiệu đã đăng ký của ETS. Trang web này không liên quan đến ETS.',
  termsS4Title: '4. Dịch vụ có phí và thanh toán',
  termsS4Body: 'Đăng ký Premium được xử lý qua dịch vụ thanh toán bên thứ ba (Dodo Payments/PayPal). Phí được tính tự động hoặc một lần tùy gói. Giá có thể bao gồm VAT. Xem chính sách hoàn tiền riêng.',
  termsS5Title: '5. Miễn trừ trách nhiệm',
  termsS5Body: 'Điểm đề mô phỏng và tài liệu học tập chỉ mang tính tham khảo, không đảm bảo kết quả thi TOEFL thực tế.',
  termsS6Title: '6. Hành vi bị cấm',
  termsS6Body: 'Nghiêm cấm sao chép hoặc phân phối câu hỏi trái phép, tạo tải quá mức, chia sẻ tài khoản và các hoạt động bất hợp pháp.',
  termsS7Title: '7. Thay đổi và ngừng dịch vụ',
  termsS7Body: 'Nhà điều hành có thể thay đổi hoặc ngừng dịch vụ mà không cần thông báo trước.',
  termsS8Title: '8. Hủy đăng ký',
  termsS8Body: 'Đăng ký có phí có thể hủy bất kỳ lúc nào. Sau khi hủy, bạn vẫn sử dụng được tính năng premium đến hết kỳ thanh toán.',
  termsS9Title: '9. Thay đổi điều khoản',
  termsS9Body: 'Điều khoản có thể được thay đổi khi cần thiết. Việc tiếp tục sử dụng dịch vụ đồng nghĩa với việc chấp nhận điều khoản mới.',

  refundPageTitle: 'Chính sách hoàn tiền — Power TOEFL',
  refundPageDesc: 'Chính sách hoàn tiền đăng ký Premium Power TOEFL.',
  refundHeading: 'Chính sách hoàn tiền',
  refundLastUpdated: 'Cập nhật lần cuối: 15 tháng 4, 2026',
  refundS1Title: '1. Nguyên tắc hoàn tiền',
  refundS1Body: 'Do tính chất của sản phẩm số, về nguyên tắc sẽ không hoàn tiền.',
  refundS2Title: '2. Trường hợp hoàn tiền ngoại lệ',
  refundS2Body: 'Tuy nhiên, có thể hoàn tiền theo diện ngoại lệ nếu pháp luật yêu cầu, bị trùng thanh toán, không cung cấp dịch vụ, hoặc có lỗi kỹ thuật nghiêm trọng.',
  refundS3Title: '3. Cách liên hệ',
  refundS3Body: 'Vui lòng dùng kênh hỗ trợ/đóng góp ý kiến để hỏi về hoàn tiền. Liên hệ: skdaks0731@gmail.com',
  refundS4Title: '4. Hủy đăng ký',
  refundS4Body: 'Bạn có thể hủy gói trả phí bất kỳ lúc nào. Sau khi hủy, bạn vẫn dùng được đến hết kỳ thanh toán hiện tại và sẽ không bị trừ thêm.',
  refundS5Title: '',
  refundS5Body: '',
  refundS6Title: '',
  refundS6Body: '',

  footerPrivacy: 'Chính sách bảo mật',
  footerTerms: 'Điều khoản sử dụng',
  footerRefund: 'Chính sách hoàn tiền',
  footerAbout: 'Giới thiệu',
  footerGuide: 'Hướng dẫn học',
  guideLabel: 'Hướng dẫn học',
  guideDesc: 'Chiến lược theo kỹ năng, điểm số và so sánh kỳ thi',

  aboutPageTitle: 'Đề thi thử TOEFL miễn phí + AI phân tích điểm yếu — Power TOEFL là gì',
  aboutPageDesc: 'Đề thi mô phỏng 4 kỹ năng dạng 2026, AI phân tích điểm yếu, tự động ôn lại lỗi sai — tất cả miễn phí.',
  aboutHeading: 'Power TOEFL — Nền tảng luyện thi TOEFL mô phỏng',
  aboutS1Title: 'Power TOEFL là gì?',
  aboutS1Body: 'Power TOEFL là nền tảng đề thi mô phỏng trực tuyến miễn phí dành cho người luyện thi TOEFL. Cung cấp đề 4 kỹ năng dạng 2026, tạo câu hỏi bằng AI, sổ lỗi sai và nhiều công cụ học tập khác.',
  aboutS2Title: 'Ai nên sử dụng?',
  aboutS2Body: 'Sinh viên mới bắt đầu luyện TOEFL, nhân viên cần điểm mục tiêu, người chuẩn bị làm việc ở nước ngoài, và tất cả những ai tự học TOEFL.',
  aboutS3Title: 'Tính năng chính',
  aboutFeature1: 'Đề thi mô phỏng Reading·Listening·Speaking·Writing dạng 2026 (nhiều bộ đề)',
  aboutFeature2: 'Luyện Reading·Listening·Speaking·Writing',
  aboutFeature3: 'Tạo câu hỏi theo độ khó bằng AI & phân tích điểm yếu',
  aboutFeature4: 'Tự động lưu câu sai + ôn tập theo Ebbinghaus',
  aboutFeature5: 'Bảng quy đổi điểm và từ vựng TOEFL',
  aboutS4Title: 'Miễn phí vs Premium',
  aboutS4Body: 'Miễn phí sử dụng đề thi, luyện theo phần, bảng điểm. Premium (Pro) tạo đề AI không giới hạn, không quảng cáo, dùng tất cả bộ đề.',
  aboutS5Title: 'Tại sao kỹ năng cải thiện?',
  aboutS5Body: 'Ôn tập thông minh theo đường cong quên Ebbinghaus, phân tích điểm yếu từng phần bằng AI, môi trường thi thử dạng 2026.',
  aboutS6Title: 'Mối quan hệ với ETS',
  aboutS6Body: 'Power TOEFL không liên kết hoặc được ETS chứng nhận. TOEFL® là thương hiệu đã đăng ký của ETS. Trang web này hoạt động độc lập.',
  aboutS7Title: 'Liên hệ',
  aboutS7Body: 'Mọi thắc mắc về dịch vụ, vui lòng gửi email tới skdaks0731@gmail.com.',
  aboutCtaHeading: 'Bắt đầu ngay thôi',
  aboutCtaDesc: 'Thử sức với đề thi mô phỏng miễn phí.',
  aboutCtaStart: 'Bắt đầu thi thử',
  aboutCtaPricing: 'Xem gói Premium',

  resumeTest: 'Tiếp tục',
  resumeDesc: '{0} Lần {1} — {2}/{3} câu',
  progressLabel: 'Tiến độ',
  timerLabel: 'Thời gian còn lại',
  timeUp: 'Hết giờ!',
  navHome: 'Trang chủ',
  navSettings: 'Mẹo',

  grammarSectionTitle: 'Sổ tay ngữ pháp tiếng Anh',
  grammarSectionDesc: 'Ngữ pháp cần thiết cho TOEFL',
  grammarViewAll: 'Xem tất cả',
  grammarChapter: 'Chương',

  aiPracticeTitle: 'AI tạo đề TOEFL không giới hạn — Chọn Part + độ khó, ra đề ngay | Power TOEFL',
  aiPracticeDesc: 'Chọn Part và độ khó, AI tạo đề TOEFL kèm giải thích ngay lập tức. Luyện miễn phí mỗi ngày với đề mới hoàn toàn.',
  aiPracticeH1: '✨ Luyện đề TOEFL bằng AI',
  aiPracticeSub: 'AI tạo câu hỏi TOEFL theo độ khó phù hợp với bạn.',
  aiPartLabel: 'Phần',
  aiDiffLabel: 'Độ khó',
  aiBeginner: 'Cơ bản (1.0–2.5)',
  aiIntermediate: 'Trung cấp (3.0–4.5)',
  aiAdvanced: 'Nâng cao (5.0–6.0)',
  aiGenerate: 'Tạo đề',
  aiGenerating: 'Đang tạo...',
  aiRemainingToday: 'Còn {0} lần tháng này',
  aiLimitReached: 'Đã dùng hết credit AI tháng này',
  aiLimitUpgrade: 'Mua thêm credit hoặc nâng cấp gói!',
  aiUpgrade: 'Nâng cấp',
  aiListenPrompt: '🔊 Câu hỏi LC nên nghe âm thanh khi làm bài',
  aiPlayAudio: 'Phát âm thanh',
  aiStopAudio: 'Dừng',
  aiCorrect: '✅ Đúng rồi!',
  aiWrong: '❌ Sai rồi.',
  aiCorrectAnswer: 'Đáp án: {0}',
  aiPrev: 'Trước',
  aiNext: 'Tiếp',
  aiNewQuestions: 'Đề mới',
  aiEmptyTitle: 'Tạo đề bằng AI',
  aiEmptyDesc: 'Chọn phần và độ khó rồi nhấn "Tạo đề".',
  aiLoadingMain: 'AI đang tạo và kiểm tra câu hỏi...',
  aiLoadingSub: 'Mất khoảng 10-20 giây',

  statsTitle: 'Thống kê luyện thi TOEFL — Power TOEFL',
  statsDesc: 'Xem thống kê học TOEFL: tỷ lệ đúng, sổ lỗi sai, tiến độ ôn tập.',
  statsH1: '📊 Thống kê học tập',
  statsLoginPrompt: 'Đăng nhập để xem thống kê học tập.',
  statsTotalQuizzes: 'Tổng bài thi',
  statsTotalQuestions: 'Tổng câu hỏi',
  statsAccuracy: 'Tỷ lệ đúng',
  statsLast7Days: '7 ngày gần đây',
  statsWrongSummary: 'Tổng hợp sổ lỗi',
  statsViewAll: 'Xem tất cả',
  statsTotalWrong: 'Tổng sai',
  statsReviewed: 'Đã ôn',
  statsPending: 'Chưa ôn',
  statsTopicAccuracy: 'Tỷ lệ đúng theo chủ đề',
  statsAttempts: '{0} lần',
  statsEmpty: 'Chưa có dữ liệu. Hãy thử làm quiz ngữ pháp!',
  statsStartGrammar: 'Bắt đầu ngữ pháp',

  pricingTitle: 'Miễn phí chưa đủ? — So sánh gói Power TOEFL Pro (199.000₫/tháng) | 2026',
  pricingDesc: 'Miễn phí luyện tập hàng ngày vs Pro AI không giới hạn · không quảng cáo · mở khóa toàn bộ đề.',

  testLCTitle: 'Đề thi thử TOEFL Reading miễn phí — Academic passages | 2026',
  testLCDesc: 'Làm đề thi thử TOEFL Reading dạng 2026 miễn phí. Academic passages, sổ lỗi sai tự động lưu.',
  testRCTitle: 'Đề thi thử TOEFL Listening miễn phí — Conversations & Lectures | 2026',
  testRCDesc: 'Làm đề thi thử TOEFL Listening dạng 2026 miễn phí. Conversations và Lectures, AI giải thích.',

  reviewTitle: 'Ôn tập hôm nay',
  reviewDesc: 'Hệ thống ôn tập thông minh theo đường cong quên Ebbinghaus',
  reviewSubtitle: 'Ôn tập đúng thời điểm theo đường cong quên lãng',
  reviewRemaining: 'Cần ôn tập',
  reviewProgress: 'Tiến độ ôn tập',
  reviewCompleted: '🎉 Hoàn thành ôn tập hôm nay!',
  reviewCompletedDesc: 'Đã ôn tập {0} câu',
  reviewEmpty: 'Không có câu nào cần ôn tập hôm nay',
  reviewEmptyDesc: 'Đã ôn tập hết hoặc chưa có câu sai.',
  reviewStage: 'Giai đoạn {0}',
  reviewNextInterval: 'Mỗi {0} ngày',
  reviewCorrect: 'Đúng! Chuyển sang giai đoạn tiếp theo.',
  reviewWrong: 'Sai. Quay lại giai đoạn 1.',
  reviewNextReview: 'Ôn tập tiếp: sau {0} ngày',
  reviewResetMsg: 'Trả lời sai, sẽ ôn lại sau 1 ngày.',
  reviewNext: 'Câu tiếp',
  reviewFinish: 'Hoàn thành',
  reviewHowItWorks: 'Nguyên lý ôn tập Ebbinghaus',
  reviewDaysLater: '{0} ngày',
  reviewExplanation: 'Câu sai được ôn theo chu kỳ 1→3→7→14→30→60 ngày. Đúng thì lên giai đoạn tiếp, sai thì quay về giai đoạn 1.',
  notifTitle: 'Thông báo',
  notifEmpty: 'Không có thông báo mới',
  notifMarkAllRead: 'Đánh dấu đã đọc',
  timeJustNow: 'vừa xong',
  timeMinutes: '{0} phút trước',
  timeHours: '{0} giờ trước',
  timeDays: '{0} ngày trước',
  scoreCardEstimated: 'Điểm ước tính',
  scoreCardCorrect: 'Đúng',
  scoreCardIncorrect: 'Sai',
  scoreCardAccuracy: 'Tỷ lệ đúng',
  pushTitle: 'Nhận thông báo học tập',
  pushDesc: 'Nhắc nhở ôn tập và chuỗi học tập liên tục.',
  pushEnable: 'Bật thông báo',
  navReview: 'Ôn tập',
  navStats: 'Thống kê',
  navPremium: 'Gói Pro',
  navSubscription: 'Quản lý gói',
  roundDetailHeading: 'Đề thi thử TOEFL',
  roundDetailOtherRounds: 'Xem đề khác',
  roundSuffix: '',
  footer7DayPlan: 'Kế hoạch 7 ngày',
  footerTrapPatterns: 'Bẫy đề thi',
  pwaAddToHome: '📱 Thêm vào màn hình chính',
  pwaAddToHomeDesc: 'Mở nhanh như ứng dụng! Học cả khi offline',
  pwaInstall: 'Cài đặt',
  pwaIOSGuide: 'Chia sẻ → Thêm vào Home',
  aiQuizTitle: '🤖 Bài tập AI',
  aiQuizDesc: 'Câu hỏi TOEFL Grammar do AI tạo',
  aiQuizGenerateDesc: 'AI tạo 5 câu hỏi dạng TOEFL Grammar theo thời gian thực.',
  aiQuizGenerate: 'Tạo câu hỏi AI',
  aiQuizGenerating: '🤖 AI đang tạo câu hỏi...',
  aiQuizGeneratingTime: 'Mất khoảng 5-10 giây',
  aiQuizNew: 'Câu mới',
  aiQuizStats: 'Thống kê:',
  aiQuizTimes: 'lần',
  aiQuizCheckAnswers: 'Kiểm tra đáp án',
  aiQuizPerfect: '🎉 Đúng hết!',
  aiQuizCorrectCount: 'Đúng',
  aiQuizSaving: 'Đang lưu...',
  aiQuizTryNew: 'Thử câu hỏi mới',
  aiQuizError: 'Tạo câu hỏi AI thất bại. Vui lòng thử lại.',
  tipsDetailStrategy: 'Chi tiết',
  tips7DayTitle: '🗓️ Kế hoạch 7 ngày trước thi',
  tips7DayDesc: 'Tối đa hóa điểm với kế hoạch cuối',
  tipsTrapTitle: '⚠️ Tổng hợp bẫy đề thi',
  tipsTrapDesc: 'Nắm 5 bẫy phổ biến nhất',
  pricingSaveBadge: 'Giảm 30%',
  pricingPerMonth: 'tháng',
  pricingSSL: 'Thanh toán an toàn',
  pricingCurrentPlan: 'Gói hiện tại',
  pricingFaqQ1: 'Miễn phí và Pro khác nhau thế nào?',
  pricingFaqA1: 'Gói miễn phí có câu hỏi Reading·Listening cơ bản và 1 lần AI/ngày. Pro có AI không giới hạn, phản hồi AI cho Speaking·Writing, phân tích 4 kỹ năng, và không quảng cáo.',
  pricingFaqQ2: 'Có thể hoàn tiền không?',
  pricingFaqA2: 'Do tính chất của sản phẩm số, về nguyên tắc sẽ không hoàn tiền. Tuy nhiên, có thể hoàn tiền theo diện ngoại lệ nếu pháp luật yêu cầu, bị trùng thanh toán, không cung cấp dịch vụ, hoặc có lỗi kỹ thuật nghiêm trọng.',
  pricingFaqQ3: 'Làm sao để hủy đăng ký?',
  pricingFaqA3: 'Bạn có thể hủy bất cứ lúc nào tại trang Đăng ký của tôi. Sau khi hủy, bạn vẫn sử dụng được đến hết kỳ hạn.',
  pricingFaqQ4: 'Lifetime và Pro năm khác nhau thế nào?',
  pricingFaqA4: 'Lifetime thanh toán một lần, dùng vĩnh viễn. Pro năm cần gia hạn mỗi năm.',
  proBadgeLabel: 'Pro',
  pricingCard: 'Thẻ tín dụng',
  pricingPaymentSuccess: 'Đăng ký Premium thành công!',
  pricingPaymentCancelled: 'Thanh toán đã bị hủy',
  pricingLoginRequired: 'Cần đăng nhập',
  pricingPaymentError: 'Tạo thanh toán thất bại.',
  subLoginRequired: 'Cần đăng nhập.',
  grammarSystematic: 'Học ngữ pháp có hệ thống',
  grammarBookTitle: 'Sổ tay ngữ pháp TOEFL',
  grammarBookDesc: 'Học 20 chủ đề ngữ pháp quan trọng cho TOEFL. Mỗi chương có ví dụ và bài tập.',
  grammarTestAfter: 'Học xong thì kiểm tra ngay!',
  grammarTestAfterDesc: 'Xem ngữ pháp đã học xuất hiện trong TOEFL thực tế như thế nào',
  grammarMockTest: 'Mock Test',
  grammarDoneTitle: 'Học ngữ pháp xong rồi?',
  grammarDoneDesc: 'Áp dụng kiến thức vào đề thi thử. Câu sai tự động lưu vào sổ lỗi!',
  grammarStartRC: 'Bắt đầu RC Mock Test',
  grammarPracticePart5: 'Luyện Grammar',
  grammarCourseName: 'TOEFL Grammar Complete Guide',
  grammarBreadcrumb: 'Ngữ pháp TOEFL',
  grammarHome: 'Trang chủ',
  grammarExamples: 'Ví dụ thực tế',
  grammarTestKnowledge: '📝 Kiểm tra kiến thức',
  grammarTestKnowledgeDesc: 'Thử làm câu hỏi thực tế về ngữ pháp vừa học!',
  grammarCheckAnswers: 'Kiểm tra đáp án',
  grammarPerfect: '🎉 Đúng hết!',
  grammarCorrectCount: 'Đúng',
  grammarMockCTA: '🔥 Kiểm tra với đề thi thử!',
  grammarMockCTADesc: 'RC 100 câu + sổ lỗi sai tự động',
  grammarStartRCMock: 'Bắt đầu RC Mock Test',
  grammarPractice5: 'Luyện Grammar',
  grammarTestInPractice: 'Thử trong thực tế!',
  grammarTestInPracticeDesc: 'Xem điểm ngữ pháp này xuất hiện trong TOEFL thực tế.',
  grammarRelated: '📚 Ngữ pháp liên quan',
  wrongAnswersGrammarAI: 'Grammar AI',
  streakDays: 'ngày',
  streakLabel: 'Học liên tục',
  leaderboardTitle: 'Bảng xếp hạng',
  leaderboardWeekly: 'Tuần',
  leaderboardMonthly: 'Tháng',
  leaderboardLoading: 'Đang tải...',
  loadingQuestions: 'Đang tải câu hỏi...',
  leaderboardEmpty: 'Chưa có dữ liệu {period} này',
  leaderboardEmptyWeek: 'tuần',
  leaderboardEmptyMonth: 'tháng',
  leaderboardHint: 'Làm bài thi sẽ tự động xếp hạng!',
  leaderboardRank: 'Hạng',
  leaderboardNickname: 'Tên',
  leaderboardSolved: 'Số câu',
  leaderboardAccuracy: 'Tỷ lệ đúng',
  leaderboardMe: 'Tôi',
  leaderboardMyRank: '🏅 Hạng của tôi: {rank}',
  tipsCoreTips: 'Mẹo quan trọng',
  tipsStrategy: 'Chiến lược thực tế',
  tipsCTA: 'Đã học chiến lược, vào thi thật!',
  testScrollHint: 'Cuộn xuống để xem câu hỏi và đáp án',
  testPart1Label: 'Academic Reading',
  testPart2Title: 'Conversations',
  testPart2Desc: 'Nghe và chọn đáp án',
  testPart3Label: 'Lectures',
  streak7: 'Học liên tục 1 tuần!',
  streak14: 'Đạt 2 tuần liên tục!',
  streak30: 'Tuyệt vời! 1 tháng liên tục!',
  reviewItems: 'câu',
  reviewTodayLabel: 'Ôn tập hôm nay',
  reviewGoLabel: '📚 Đi ôn tập →',

  creditBuyBtn: 'Mua credit',
  creditBuyTitle: 'Mua credit AI',
  creditBuyDesc: 'Mua thêm credit cho phản hồi AI Speaking/Writing và luyện tập AI.',
  creditBuyError: 'Không thể bắt đầu thanh toán',
  creditBuyNote: 'Thanh toán qua PayPal. Credit được cộng ngay sau khi thanh toán.',
  creditUnit: 'credit',

  speakingPageH1: 'Luyện TOEFL Speaking 2026',
  speakingPageSub: '{count}+ đề Speaking miễn phí — Listen and Repeat · Interview',
  speakingPageTitle: 'Luyện TOEFL Speaking 2026 — {count}+ đề miễn phí | Power TOEFL',
  speakingPageDesc: 'Đề luyện TOEFL Speaking {count}+. Bài mẫu, tiêu chí chấm điểm, AI feedback. 2026.',
  speakingAllTasks: 'Tất cả',
  speakingNoPrompts: 'Chưa có đề Speaking',
  speakingNoPromptsSub: 'Đề đang được tạo. Vui lòng quay lại sau!',
  speakingResponseTime: 'Thời gian trả lời',

  writingPageH1: 'Luyện TOEFL Writing 2026',
  writingPageSub: '{count}+ đề Writing miễn phí — Build a Sentence · Email · Academic Discussion',
  writingPageTitle: 'Luyện TOEFL Writing 2026 — {count}+ đề miễn phí | Power TOEFL',
  writingPageDesc: 'Đề luyện TOEFL Writing {count}+. Bài mẫu, tiêu chí chấm điểm. 2026.',
  writingAllTasks: 'Tất cả',
  writingNoPrompts: 'Chưa có đề Writing',
  writingNoPromptsSub: 'Đề đang được tạo. Vui lòng quay lại sau!',

  catPageTitle: 'TOEFL Adaptive Test (CAT) — AI tự điều chỉnh độ khó | Power TOEFL',
  catPageDesc: 'Bài thi TOEFL thích ứng máy tính. AI tự điều chỉnh độ khó theo tỷ lệ đúng.',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: 'Độ khó tự điều chỉnh theo tỷ lệ đúng. {count} câu mỗi phiên.',
  catNote: "ℹ️ Lưu ý: Bài thi TOEFL iBT thật là bài thi tuyến tính (không thích ứng). Practice CAT này là công cụ học tập điều chỉnh độ khó theo kết quả của bạn để nhanh chóng xác định trình độ — không phải mô phỏng định dạng thi thật.",
  catSelectSection: 'Chọn phần',
  catStartBtn: 'Bắt đầu Adaptive Test',
  catLoading: 'Đang tải câu tiếp theo...',
  catNoMore: 'Không còn câu hỏi nào',
  catComplete: 'Adaptive Test hoàn tất',
  catAccuracy: 'Tỷ lệ đúng',
  catFinalLevel: 'Mức độ cuối',
  catTryAgain: 'Thử lại',
  catViewResults: 'Xem kết quả',
  catNext: 'Tiếp',
  catExplanation: 'Giải thích',
  catStop: 'Dừng',
  catPlayAudio: '🔊 Phát âm thanh',
  catReadingPassage: 'Reading Passage',

  scoreReadingHeader: 'Reading (0~30 điểm)',
  scoreListeningHeader: 'Listening (0~30 điểm)',
  scoreSpeakingHeader: 'Speaking (0~30 điểm)',
  scoreWritingHeader: 'Writing (0~30 điểm)',
  scoreSpeakingDesc: '4 bài chấm 0~4 điểm rồi quy đổi thành 30 điểm',
  scoreWritingDesc: '2 bài chấm 0~5 điểm rồi quy đổi thành 30 điểm',
  scoreSpeakingLevels: [
    ['4 điểm (Good)', '27~30', 'Trả lời lưu loát, chính xác, logic'],
    ['3 điểm (Fair)', '19~26', 'Khá rõ ràng nhưng có lỗi'],
    ['2 điểm (Limited)', '11~18', 'Giao tiếp cơ bản nhưng hạn chế'],
    ['1 điểm (Weak)', '1~10', 'Khó truyền đạt ý nghĩa'],
  ] as [string, string, string][],
  scoreWritingLevels: [
    ['5 điểm (Good)', '27~30', 'Bài luận logic, cụ thể, ngữ pháp chính xác'],
    ['4 điểm (Fair)', '22~26', 'Tốt nhìn chung nhưng thiếu sót'],
    ['3 điểm (Limited)', '15~21', 'Có cấu trúc cơ bản nhưng thiếu phát triển'],
    ['2 điểm (Weak)', '8~14', 'Lạc đề hoặc cấu trúc không rõ'],
    ['1 điểm (Very Weak)', '1~7', 'Gần như không truyền đạt được'],
  ] as [string, string, string][],
  scoreGuideDescs: [
    'Cần Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+. Đủ điều kiện đại học top.',
    'Mục tiêu Reading 22+ / Listening 22+. Đạt tiêu chuẩn hầu hết đại học.',
    'Trình độ tiếng Anh học thuật cơ bản. Nhập học có điều kiện. Cần học tập trung.',
    'Giai đoạn cơ bản. Nên tập trung Reading và Listening.',
  ],
  // --- Flashcard mode ---
  vocabFlashcardStart: "Bắt đầu thẻ ghi nhớ",
  vocabFlashcardStop: "Dừng thẻ ghi nhớ",
  vocabFlashcardEmpty: "Hãy thêm từ trước khi bắt đầu thẻ ghi nhớ.",
  vocabFlashcardSpeed: "Tốc độ",
  vocabFlashcardSpeedSlow: "Chậm",
  vocabFlashcardSpeedNormal: "Bình thường",
  vocabFlashcardSpeedFast: "Nhanh",
  vocabFlashcardShuffle: "Trộn",
  vocabFlashcardPrev: "Trước",
  vocabFlashcardNext: "Tiếp",
  vocabFlashcardFlip: "Lật",
  vocabFlashcardProgress: "{current} / {total}",
};

export default vi;
